<script setup lang="ts">
const { hasCartItemErrors } = useCart()

const checkout = () => {
  navigateTo('/checkout/')
}
</script>

<template>
  <div class="cart-cta__container">
    <button
      class="cart-cta"
      :disabled="hasCartItemErrors"
      data-testid="cart-cta-checkout"
      @click.prevent="checkout()"
    >
      <span>{{ $t('Proceed to checkout') }}</span>
      <NuxtIcon name="icon:arrow" />
    </button>
  </div>
</template>
